import React from "react";
import { motion } from "framer-motion";
import { Map, MapPin, ShieldCheck } from "lucide-react";
import { useLang } from "../i18n";

export function HowItWorks() {
  const { t } = useLang();
  const steps = [
    { icon: Map, t: t("how_1_t"), d: t("how_1_d") },
    { icon: MapPin, t: t("how_2_t"), d: t("how_2_d") },
    { icon: ShieldCheck, t: t("how_3_t"), d: t("how_3_d") },
  ];
  return (
    <section data-testid="how-it-works" className="bg-softpink px-5 py-20 sm:px-8 sm:py-28">
      <div className="mx-auto max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="text-3xl font-semibold tracking-tight text-graphite sm:text-4xl">
            {t("how_title")}
          </h2>
          <p className="mt-3 max-w-xl text-base leading-relaxed text-textsec">{t("how_sub")}</p>
        </motion.div>
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              data-testid={`how-step-${i + 1}`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="rounded-panel bg-white p-7 shadow-soft"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-softpink text-dusty">
                <s.icon size={22} strokeWidth={1.5} />
              </div>
              <div className="mt-5 text-xs font-semibold uppercase tracking-wider text-dusty">
                0{i + 1}
              </div>
              <h3 className="mt-2 text-lg font-semibold text-graphite">{s.t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-textsec">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
